<template>
  <md-dialog :md-active.sync="localVisible">
    <md-dialog-title>{{ title }}</md-dialog-title>

    <md-dialog-content>
      <md-field>
        <label>Reaction</label>
        <md-select v-model="localForm.reaction" required>
          <md-option v-for="option in reactions" :key="option" :value="option">
            {{ option }}
          </md-option>
        </md-select>
      </md-field>

      <md-field>
        <label>Comment</label>
        <md-textarea v-model="localForm.comment" placeholder="Write comment..." />
      </md-field>
    </md-dialog-content>

    <md-dialog-actions>
      <md-button class="md-primary" @click="submit">Submit</md-button>
      <md-button class="md-accent" @click="$emit('close')">Cancel</md-button>
    </md-dialog-actions>
  </md-dialog>

<!--  <md-dialog :md-active.sync="modal.checkinSupervisor.active" class="supervisor-dialog">-->
<!--    <md-dialog-title>Checkin Supervisor</md-dialog-title>-->
<!--    <md-dialog-content>-->
<!--      <div class="modal-content">-->
<!--        <div class="labourer-info">-->
<!--          <p><strong>Labourer:</strong> {{ getFullName() }}</p>-->
<!--          <p><strong>Work Point:</strong> {{ getWorkPointNameFromItem() }}</p>-->
<!--          <p><strong>Activity:</strong> {{ getActivityNameFromItem() }}</p>-->
<!--          <p><strong>Takeon Number:</strong> {{ selectedSchedule ? selectedSchedule.takeon_number : '' }}</p>-->
<!--        </div>-->

<!--        <md-field>-->
<!--          <label>Status *</label>-->
<!--          <md-select v-model="localForm.checkinSupervisor.reaction" required>-->
<!--            <md-option value="on_time">On Time</md-option>-->
<!--            <md-option value="late">Late</md-option>-->
<!--            <md-option value="note_present">Late</md-option>-->
<!--          </md-select>-->
<!--        </md-field>-->

<!--        <md-field>-->
<!--          <label>Confirmation Time</label>-->
<!--          <md-input v-model="localForm.checkinSupervisor.time" type="datetime-local"/>-->
<!--        </md-field>-->

<!--        <md-field>-->
<!--          <label>Comments (Optional)</label>-->
<!--          <md-textarea v-model="localForm.checkinSupervisor.comment" rows="3"/>-->
<!--        </md-field>-->
<!--      </div>-->
<!--    </md-dialog-content>-->
<!--    <md-dialog-actions>-->
<!--      <md-button class="md-success" @click="confirmCheckinSupervisor">Confirm Checkin Supervisor</md-button>-->
<!--      <md-button class="md-danger" @click="localForm.checkinSupervisor.active = false">Cancel</md-button>-->
<!--    </md-dialog-actions>-->
<!--  </md-dialog>-->
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: String,
        reactions: Array,

        form: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            localVisible: this.visible,
            localForm: { ...this.form }
        };
    },
    watch: {
        visible (val) {
            this.localVisible = val;
        },
        localVisible (val) {
            this.$emit('update:visible', val);
        },
        form: {
            handler (val) {
                this.localForm = { ...val };
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        submit () {
            if (!this.localForm.reaction) {
                this.$emit('invalid', 'Reactions is required');
                return;
            }

            this.$emit('submit',  { ...this.localForm });
        },

      // getFullName: function (labourer) {
      //   if (!labourer) return 'N/A';
      //   var parts = [];
      //   if (labourer.first_name) parts.push(labourer.first_name);
      //   if (labourer.middle_name) parts.push(labourer.middle_name);
      //   if (labourer.last_name) parts.push(labourer.last_name);
      //   return parts.length ? parts.join(' ') : 'N/A';
      // },
    },
};
</script>
